import { api } from './client';

export async function fetchNetworkMetrics(range = '30m') {
  const { data } = await api.get('/v1/network-metrics', {
    params: { range },
  });

  return {
    range: data?.range ?? range,
    data: Array.isArray(data?.data) ? data.data : [],
    latest: data?.latest ?? null,
  };
}
